import { Easing } from 'react-native-reanimated';
import { FadeIn, FadeInDown } from 'react-native-reanimated';

/** Shared spring — cards, progress, segmented pill. */
export const JOURNEY_SPRING = { stiffness: 140, damping: 28, mass: 0.95 };

const STEP_MS = 200;
const LIST_BASE_DELAY = 10;
const LIST_STEP_DELAY = 18;
const PANEL_BASE_DELAY = 12;
const PANEL_STEP_DELAY = 24;

export function journeyStepEntering() {
  return FadeIn.duration(STEP_MS).easing(Easing.out(Easing.quad));
}

export function journeyListItemEntering(index: number) {
  return FadeInDown.delay(Math.min(LIST_BASE_DELAY + index * LIST_STEP_DELAY, 56)).duration(180);
}

export function journeyPanelEntering(index: number) {
  return FadeInDown.delay(Math.min(PANEL_BASE_DELAY + index * PANEL_STEP_DELAY, 72)).duration(200);
}
